var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-footer"},[_c('p',{staticClass:"footer-text"},[_vm._v("@ GEA 10th Annual Conference")]),_c('div',{staticClass:"to-top",on:{"click":_vm.handleToTop}},[_c('svg-to-top',{staticClass:"svg"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }